module.exports = __webpack_public_path__ + "img/icon-organizations.6e75ce1a.svg";